<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="#ac8a2e"
          inline
          title="Consulta profesional"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="jugador"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="dataForm.jugador_id"
                        color="gold"
                        :error-messages="errors"
                        label="Jugador"
                        item-value="id"
                        item-text="fullName"
                        :items="jugadores" clearable
                        :disabled="esJugador"
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.fullName" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                          <v-text-field v-model="fecha_solicitud" color="gold" :error-messages="errors" label="Fecha Solicitud" readonly v-on="on" />
                        </validation-provider>
                      </template>
                      <v-tabs
                        v-model="active_tab1"
                        fixed-tabs
                        color="#ac8a2e"
                      >
                        <v-tab>
                          Fecha
                        </v-tab>
                        <v-tab-item>
                          <v-date-picker
                            v-model="dataForm.fecha_solicitado"
                            color="gold"
                            landscape
                            scrollable
                            locale="es-419"
                            no-title
                            @input="active_tab1 = 1"
                          >
                          </v-date-picker>
                        </v-tab-item>
                        <v-tab :key=1>
                            Hora
                        </v-tab>
                          <v-tab-item>
                            <v-time-picker
                              v-model="dataForm.hora_solicitado"
                              format="ampm"
                              scrollable
                              flat
                            >
                              <v-btn text block @click="menu = false">
                                Ok
                              </v-btn>
                            </v-time-picker>
                            </v-tab-item>
                        </v-tabs>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select v-model="dataForm.medico_id" @change="setCargo" color="gold" label="Profesional" item-value="id" item-text="fullName" :items="medicos" clearable>
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.fullName" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                  <validation-provider v-slot="{ errors }" name="especialidad" rules="required">
                    <v-select v-model="dataForm.especialidad_id" color="gold" :disabled="medico" :error-messages="errors" label="Especialidad" item-value="id" item-text="descripcion" :items="cargos" clearable>
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.descripcion" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="descripción"
                      rules="max:250"
                    >
                      <v-textarea
                        v-model="dataForm.descripcion_jugador"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Descripción"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" class="pb-0 pt-0">
                    <v-card>
                      <v-card-title class="white">
                        <v-row>
                          <v-col cols="auto" class="pl-0 black--text">
                            <v-icon class="black--text" large>
                              mdi-file-document
                            </v-icon>
                            <span style="font-size: 115%"></span> Documentación
                          </v-col>
                          <v-spacer> </v-spacer>
                          <template>
                            <v-col cols="auto" class="black--text">
                              <v-tooltip content-class="top" top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="black--text" v-bind="attrs" v-on="on" @click.stop="open(true)">
                                    mdi-plus
                                  </v-icon>
                                </template>
                                <span>Agregar</span>
                              </v-tooltip>
                            </v-col>
                          </template>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-chip-group
                          active-class="primary--text"
                          column
                        >
                          <v-chip
                            class="ma-2"
                            close
                            v-for="(item, key) in dataForm.documentosJugador" :key="key"
                            @click="openFile(item.id)"
                            @click:close="eliminarChip(item.id, key)"
                          >
                            <span style="font-size: 150%"></span> {{ item.nombre }}
                          </v-chip>
                        </v-chip-group>
                      </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="end">
                      <v-btn :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
      <v-col cols="auto">
      <template>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Agregar Documentación</span>
            </v-card-title>
            <v-card-text>
              <base-upload-files folder="/documentaciones/consultas-medicas" tipo="pdf" :documento-id="documentoId" @documento="newFile = $event" />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="red"
                text
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="agregarChip"
              >
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
    },

    data: () => ({
      tittle: 'Nuevo turno',
      menu: false,
      dialog: false,
      esJugador: false,
      active_tab: 0,
      active_tab1: 0,
      newFile: null,
      documentoId: 0,
      medicos: [],
      jugadores: [],
      cargos: [],
      dataForm: {
        documentosJugador: [],
        especialidad_id: '',
        fecha_solicitado: '',
        hora_solicitado: '',
      },
    }),
    computed: {
      fecha_solicitud: function () {
        return this.dataForm.fecha_solicitado + ' ' + this.dataForm.hora_solicitado
      },
      medico: function () {
        if (this.dataForm.medico_id) {
          return true
        }
        return false
      },
    },

    created () {
      this.getJugadores()
      this.getMedicos()
      this.getCargosMedicos()
      this.setJugador()
    },

    watch: {
      newFile (val) {
        this.documentoId = this.newFile
      },
    },
    methods: {

      getMedicos: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_medicos' }).then(response => { this.medicos = response })
      },

      getCargosMedicos: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/cargo_medico_get' }).then(response => { this.cargos = response })
      },

      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },

      setJugador: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador_loged' }).then(response => {
          if (response) {
            this.dataForm.jugador_id = response
            this.esJugador = true
          }
        })
      },

      setCargo: async function () {
        if (this.dataForm.medico_id) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get/' + this.dataForm.medico_id }).then(response => {
            this.dataForm.especialidad_id = response.cargo_id
          })
        }
      },

      validateForm (scope) {
        this.saveConsulta()
      },

      saveConsulta: async function () {
        this.dataForm.fecha_solicitud = this.fecha_solicitud
        const mode = 'postData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/consulta_medica_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de turno exitosa'] })
          this.$router.push({ name: 'Consultas profesionales' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
      },

      saveDocumentacion () {
        if (this.documentoId !== 0) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/files_get/' + this.documentoId }).then(response => {
            this.dataForm.documentosJugador.push(response)
          })
        }
      },

      deleteDocumentacion: async function (id = this.documentoId) {
        if (id !== 0) {
          await this.$http.delete('/api/files_delete/' + id)
        }
      },

      agregarChip () {
        this.saveDocumentacion()
        this.dialog = false
        this.documentoId = 0
      },

      eliminarChip (id, key) {
        this.deleteDocumentacion(id)
        this.$delete(this.dataForm.documentosJugador, key)
      },

      open () {
        this.dialog = true
      },

      close () {
        this.deleteDocumentacion()
        this.dialog = false
        this.documentoId = 0
      },

      openFile (internalid) {
        this.downloadDocument(internalid, false)
      },

      downloadDocument (internalid, isPublic) {
        this.$http.get('/api/files/download/' + internalid + '/disk/' + isPublic, { responseType: 'arraybuffer' })
          .then(response => {
            this.downloadFile(response, 'documentacion')
          }, response => {
          },
          )
      },

      downloadFile (response, filename) {
        var newBlob = new Blob([response.data], { type: 'application/pdf' })
        var url = URL.createObjectURL(newBlob)
        var a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.click()
      },

    },
  }
</script>
